var _title, _desc, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFilledError = function SvgFilledError(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "18px",
    viewBox: "0 0 21 18",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "icons8-error")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "File-upload-fail-handling",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard-Copy",
    transform: "translate(-445.000000, -147.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons8-error",
    transform: "translate(445.000000, 147.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6459512,14.8779724 L11.7770649,1.24957526 C10.8140892,-0.416525087 9.24275805,-0.416525087 8.27978232,1.24957526 L0.410896837,14.8779724 C-0.552078902,16.5440727 0.236643532,17.9044666 2.15953814,17.9044666 L17.8973099,17.9044666 C19.8202037,17.9044666 20.6058693,16.5440727 19.6459512,14.8779724 Z M8.94622292,5.11676257 C9.23052979,4.81105604 9.58820623,4.65820317 10.0284236,4.65820317 C10.468641,4.65820317 10.8263174,4.80799917 11.1106251,5.11064883 C11.3888174,5.41024083 11.5324997,5.78931691 11.5324997,6.24482022 C11.5324997,6.63306691 10.9455432,9.50670822 10.749891,11.594684 L9.33446962,11.594684 C9.16327397,9.50670822 8.52434753,6.63306691 8.52434753,6.24482022 C8.52434753,5.79543143 8.66802979,5.41941222 8.94622292,5.11676257 Z M11.0892254,15.0522249 C10.7926903,15.3395887 10.4380707,15.4863278 10.0284236,15.4863278 C9.61877727,15.4863278 9.26415771,15.3395887 8.96762179,15.0522249 C8.67108666,14.7618035 8.52434753,14.4132985 8.52434753,14.0005945 C8.52434753,13.5909473 8.67108666,13.2363278 8.96762179,12.9397927 C9.26415771,12.6432575 9.61877727,12.4965184 10.0284236,12.4965184 C10.4380707,12.4965184 10.7926903,12.6432575 11.0892254,12.9397927 C11.3857606,13.2363278 11.5324997,13.5909473 11.5324997,14.0005945 C11.5324997,14.4132985 11.3857606,14.7618035 11.0892254,15.0522249 Z",
    id: "Shape"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFilledError, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/filled-error.1ec8f447.svg";
export { ForwardRef as ReactComponent };